var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"btn btn-dark",attrs:{"href":"/profile"}},[_vm._v("Back to profile")])])
}]

export { render, staticRenderFns }